import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { TopLevelMenuComponent } from '@cumlaude/shared-components-menu';
import { UrlService } from '../../services/url.service';
import { UserMenuService } from '../../services/user-menu.service';
import { HeaderActiesService } from '../../services/header-acties.service';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { ProfielMenuComponent } from './profiel-menu/profiel-menu.component';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	imports: [TopLevelMenuComponent, IconComponent, ProfielMenuComponent],
})
export class HeaderComponent {
	private readonly headerActies = inject(HeaderActiesService);
	protected readonly userMenuService = inject(UserMenuService);
	readonly urlService = inject(UrlService);

	@ViewChild('bookmarkButton')
	bookmarkButton!: ElementRef;

	@ViewChild('feedbackButton')
	feedbackButton!: ElementRef;

	openHelp() {
		this.headerActies.openHelp();
	}

	openFeedback() {
		this.headerActies.openFeedback(this.feedbackButton);
	}

	openBookmark() {
		this.headerActies.openFavorieten(this.bookmarkButton);
	}
}
